import './Loading.css'

export default function Loading() {
    return(<div class="loading-placeholder"><h2>Loading...</h2></div>)
}